import {useStaticQuery, graphql} from 'gatsby'


export default function useSiteMetadata() {
  const data = useStaticQuery(graphql`
    query SiteMetaData {
      site {
        siteMetadata {
          title
          gateway
          pf_path
          oauth_client_id
          oauth_authorize_url
          oauth_logout_url
        }
      }
    }
  `)

  return data.site.siteMetadata
}
